import {isMobile} from '../index.js';
import {scrollTop} from '../index.js';
import TweenMax from 'gsap/src/uncompressed/TweenMax';
var raf = require('raf');
var interiaItem = $('.js-interia-scroll');
var bgItem1 = $('.page-background.layer-one');
var bgItem2 = $('.page-background.layer-two');
require('waypoints');

export function scrollAnimation() {
	$('.scroll-indicator a').click( function( event ) {
		event.preventDefault();
		var target = $('.row').eq(1);
		$('html, body').animate({
			scrollTop: target.offset().top
		}, 1600, 'swing');
	});
	setTimeout(function () {
		$('.waypoint').each(function() {
			var $element = $(this);
			var waypoints = new Waypoint({
				element: this,
				handler: function(direction) {
					var $el = $(this.element);

					if ( direction == 'down') $el.addClass('waypoint-active');
					if ( direction == 'up') $el.removeClass('waypoint-active');
				},
				offset: '92%'
			});
		});
		$('.waypoint-full').each(function() {
			var waypoints = new Waypoint({
				element: this,
				handler: function(direction) {
					var $el = $(this.element);

					if ( direction == 'down') $el.addClass('waypoint-active');
					if ( direction == 'up') {
						if ( !$el.is('.c-header__img') ) {
							$el.removeClass('waypoint-active');
						}
					}
				},
				offset: '110%'
			});
		});
	}, 1000);

	if(interiaItem) {
		interiaItem.each(function(index, el) {
			$(this).attr('data-offset', $(this).offset().top);
			$(this).attr('data-interia-speed',  0.4 * 0.2 );

			if ( $(this).parents('.row__image').find('img').height() < 250 && window.innerWidth <= 480 ) {
				$(this).parents('.row__image').css({
					'width' : '80%'
				});
			}
			if ( $(this).parents('.o-content').height() < 290 && window.innerWidth <= 480 ) {
				$(this).parents('.row').css({
					'min-height' : '60vh'
				});
			}
		});
		$(window).on('resize', function() {
			interiaItem.each(function(index, el) {
				$(this).attr('data-offset', $(this).offset().top);
			});
		});
	}
}

export function interiaScroll() {
    interiaItem.each(function(index, elem) {
        var range = $(this).data('offset') - scrollTop();
        var speed = $(this).data('interia-speed');
        TweenMax.to( $(this), 1.5, {
            y: (range * speed),
            skewY: 0,
            ease: Power4.easeOut
        }, 0);
    });
    if ( !isMobile) {
        var horizScrollPos = scrollTop() * 0.15;
        var vertScrollPos = scrollTop() * 0.2;
        bgItem1.css( 'background-position', vertScrollPos + "px " + horizScrollPos + "px" );
        bgItem2.css( 'background-position', -vertScrollPos + "px " + -horizScrollPos + "px" );
    }
}



// WEBPACK FOOTER //
// ./app/js/components/scrollAnimation.js